import logo from "./images/logo.png";
import surgery3 from "./images/surgery3.webp";
import glucometer2 from "./images/glucometer2.webp";
import health2 from "./images/health2.webp";
import realtalk1 from "./images/realtalk1.webp";
import stethoscope from "./images/stethoscope.webp";

const SingleImages = {
  logo: logo,
  surgery3: surgery3,
  glucometer2: glucometer2,
  health2: health2,
  realtalk1: realtalk1,
  stethoscope: stethoscope,
};

export default SingleImages;
